import { useMemo, useState } from 'react'
import { useSelector } from 'react-redux'
import Form from 'react-bootstrap/Form'
import { selectTranslations } from '../../services/i18n/i18nSlice'
import './QuestionEditor.css'

export default function SubjectTopicSelect({ subjects, topics, value, onChange }) {
    const t = useSelector(selectTranslations)

    const [subjectFilter, setSubjectFilter] = useState('')

    const filteredTopics = useMemo(() => {
        if (!subjectFilter) return topics
        return topics?.filter(topic => topic.subject_id === subjectFilter)
    }, [subjectFilter, topics])

    const handleToggleTopic = (topic_id) => {
        const _value = value || []
        onChange(
            _value.includes(topic_id)
                ? _value.filter(id => id !== topic_id)
                : [..._value, topic_id]
        )
    }

    return (
        <div className="subject_topic_select">
            <Form.Group className="mb-2" controlId="subject_topic_select_subject">
                <Form.Label>{t.question_bank.subject}</Form.Label>
                <Form.Select value={subjectFilter} onChange={(e) => setSubjectFilter(e.target.value)}>
                    <option value="">{t.question_bank.all_subjects}</option>
                    {subjects?.map(s => (
                        <option key={s.subject_id} value={s.subject_id}>{s.subject_name}</option>
                    ))}
                </Form.Select>
            </Form.Group>
            <Form.Label>{t.question_bank.topics}</Form.Label>
            <div className="subject_topic_select_list">
                {filteredTopics?.length ? filteredTopics.map(topic => (
                    <Form.Check
                        key={topic.topic_id}
                        type="checkbox"
                        id={`topic_check_${topic.topic_id}`}
                        label={topic.topic_name}
                        checked={(value || []).includes(topic.topic_id)}
                        onChange={() => handleToggleTopic(topic.topic_id)}
                    />
                )) : (
                    <span className="text-muted">{t.question_bank.no_topics}</span>
                )}
            </div>
        </div>
    )
}
